// Components/CenterLoader/CenterLoader.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../../Api/Customapi";
import InternalServerError from "../Errors Handling/Error 500/InternalServerError";
import { slug } from "../../utils/store";
import axios from "axios";

const fetchCenterData = async () => {
  console.log("Fetching with slug:", slug); // check this in browser console
  const response = await axios.get(`https://api.dreasey.com/api/Centers/GetCenterbySlug?Slug=${slug}`);
  return response.data;
};
export default function CenterLoader() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["centerData"],
    queryFn: fetchCenterData,
    retry: false,
  });

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="size-14 border-primary border-y-2 rounded-full py-5 animate-spin" />
      </div>
    );
  }

  if (isError) {
    if (error?.response?.status === 404) {
      return <Navigate to="/not-found" replace />;
    }
    return <InternalServerError />;
  }

  return <Outlet context={data} />;
}